<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-04-26 16:37:14
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-18 15:04:17
 * @FilePath: /partner.chaoyongtuan.com/src/components/yxAvatar/index.vue
 * 
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved. 
-->
<template>
	<el-avatar class="avatar" :size="size" :src="src" :shape="shape" :placeholder="placeholder" fit="cover">
		<template v-slot:default>
			<img src="./img/avatar.png" alt="" />
		</template>
	</el-avatar>
</template>

<script>
export default {
	name: 'yxAvatar',
	props: {
		size: {
			type: [Number, String],
			default: 'large',
		},
		src: {
			type: String,
			default: '',
		},
		shape: {
			type: String,
			default: 'circle',
		},
		placeholder: {
			type: String,
			default: 'circle',
		},
	},
	data() {
		return {};
	},
};
</script>

<style lang="less" scoped>
.avatar {
	background: #fff !important;
	flex-shrink: 0;
}
</style>
